'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useQuery } from '@tanstack/react-query';
import { usePostHogBoolFlag } from '@workspace/analytics/posthog/feature-flags-client';
import { getEmployeeByUserAndOrganisation } from '@/actions/employees';
import { getEligiblePaydayCountries } from '@/actions/salary-rewards';
import { useIsEmployee } from '@/hooks/use-employer';
import { getActiveOrganisationFromUser } from '@/lib/active-organisation';
import { SHOW_SALARY_REWARDS_FLAG } from '@/lib/salary-rewards-flags';
import { isEmployeeSalaryWalletEligible } from '@/lib/salary-wallet-access';
import { useAuthStore } from '@/stores/authStore';

export function useCanAccessSalaryWallet(): boolean {
  const isSalaryRewardsEnabled = usePostHogBoolFlag(SHOW_SALARY_REWARDS_FLAG, false);
  const isEmployee = useIsEmployee();
  const user = useAuthStore((state) => state.user);
  const userId = user?.user?.id;
  const organisationId = getActiveOrganisationFromUser(user)?.id;
  const isEnabled = isSalaryRewardsEnabled && isEmployee && !!userId && !!organisationId;

  const { data: employeeResponse } = useQuery({
    queryKey: ['employee-by-user-and-organisation', userId, organisationId],
    queryFn: () => getEmployeeByUserAndOrganisation(userId!, organisationId!),
    enabled: isEnabled,
  });

  const { data: eligibleCountriesResponse } = useQuery({
    queryKey: ['eligible-payday-countries'],
    queryFn: getEligiblePaydayCountries,
    enabled: isEnabled,
    staleTime: Infinity,
  });

  if (!isEnabled) return false;

  const eligibleCountryIds = (eligibleCountriesResponse?.data ?? []).map((country) =>
    String(country.country_id)
  );

  return isEmployeeSalaryWalletEligible({
    employee: employeeResponse?.data,
    eligibleCountryIds,
  });
}
